module.exports = __webpack_public_path__ + "static/media/tab-your-library.0b55adcf.svg";